import { useEffect, useState } from 'react';

interface ScrollOutput {
  scrollDirection: 'up' | 'down' | undefined;
  scrollY: number;
  scrollX: number;
}

function useScroll(): ScrollOutput {
  const [scrollDirection, setScrollDirection] = useState<'up' | 'down' | undefined>(undefined);
  const [lastScrollTop, setLastScrollTop] = useState<number>(0);
  const [scrollY, setScrollY] = useState<number>(0);
  const [scrollX, setScrollX] = useState<number>(0);

  useEffect(() => {
    function listener() {
      const currentScrollTop = window.scrollY || document.documentElement.scrollTop;
      const currentScrollLeft = window.scrollX || document.documentElement.scrollLeft;

      setScrollY(currentScrollTop);
      setScrollX(currentScrollLeft);

      if (currentScrollTop <= 0) {
        setScrollDirection(undefined);
      } else {
        setScrollDirection(currentScrollTop > lastScrollTop ? 'up' : 'down');
      }
      setLastScrollTop(currentScrollTop);
    }

    window.addEventListener('scroll', listener);

    return () => {
      window.removeEventListener('scroll', listener);
    };
  }, [lastScrollTop]);

  return {
    scrollY,
    scrollX,
    scrollDirection,
  };
}

export default useScroll;
